import React, { Component } from 'react'
import { connect } from 'react-redux'
import pt from 'prop-types'
import { NavLink } from 'react-router-dom'
import cn from 'classnames'
import { get } from 'lodash-es'
import { fromJS } from 'immutable'

import MainMenu from '../MainMenu/MainMenu'
import Sections from '../FeedsFilter/Sections'

import { makeGetProfileUserByUsername } from '../../modules/entities'
import { getProfileMenuOptions, getCustomMenuOptions, mobileBreakpoint } from '../../util/settings'

import LogoSymbol from '../../styles/images/logo-symbol.png'
import LogoText from '../../styles/images/logo-text.png'
import './index.scss'
import { setKnobsPanelTopMargin } from '../../modules/ui'
import Fade from '../Fade/Fade'

const headerBaseClass = 'header'
const headerScrollingClass = 'header--scroll'
const logoTextBaseClass = 'header__brand-image-text'
const logoTextScrollingClass = 'header__brand-image-text--scroll'
const logoScrollingClass = 'header__brand-image-symbol--scroll'

const defaultFeed = {
  position: 0,
  feeds: [
    {
      name: 'Home',
      to: '/',
      position: 1
    },
    {
      name: 'Highlights',
      to: '/highlights',
      position: 2
    },
    {
      name: 'Cards',
      to: '/cards',
      position: 3
    },
    {
      name: 'Collections',
      to: '/collections',
      position: 4
    }
  ]
}

const savedFeed = {
  position: 999,
  feeds: [
    {
      name: 'Saved',
      to: '/saved',
      position: 1
    }
  ]
}

class Header extends Component {
  state = { isScrollingMode: false, isMouseEntered: false, showDefaultSavedFeed: true }

  componentDidMount = () => {
    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.onScroll)
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { isMouseEntered, isScrollingMode } = this.state
    const { isMouseEntered: isNextMouseEntered, isScrollingMode: isNextScrollingMode, mods: nextMods } = nextState
    const { feedSections, mods } = this.props
    const { feedSections: nextFeedSections } = nextProps
    return (
      isMouseEntered !== isNextMouseEntered ||
      isScrollingMode !== isNextScrollingMode ||
      feedSections.hashCode() !== nextFeedSections.hashCode() ||
      get(mods, 'list.length') !== get(nextMods, 'list.length')
    )
  }

  componentDidUpdate(prevProps) {
    const { feeds: prevFeeds, mods: prevMods } = prevProps
    const { feeds, mods } = this.props

    const pFArr = prevFeeds.toList()
    const fArr = feeds.toList()

    if (pFArr.length !== fArr.length && fArr.filter(i => i.url === '/saved').length) {
      this.setState({ showDefaultSavedFeed: false })
    }

    if (mods.list.length !== prevMods.list.length) {
      this.setState({ isScrollingMode: this.isScrollingMode() })
    }
  }

  isScrollingMode = () => {
    const { mods } = this.props

    if (mods.list.length) {
      return false
    }

    return window.scrollY
  }

  onScroll = e => {
    this.setState({ isScrollingMode: this.isScrollingMode() })
  }

  onMouseEnter = e => this.setState({ isMouseEntered: true })

  onMouseLeave = e => this.setState({ isMouseEntered: false })

  render() {
    const { isScrollingMode, isMouseEntered, showDefaultSavedFeed } = this.state
    const {
      location,
      myContent,
      profileUser,
      feeds,
      feedSections: allSections,
      ui,
      setKnobsPanelTopMargin,
      user
    } = this.props
    const { isInEditPinsMode } = myContent
    const profileUsername = profileUser.get('username')
    const profileFeeds = feeds.filter(i => i.getIn(['user', 'username']) === profileUsername && !i.get('home')).toList()
    const feedSections = profileUser.get('feedSections')
    const { pathname } = location
    const segments = pathname.substr(1).split('/')
    const isFeedLocation = ['', 'search', 'feed', 'custom-feed'].includes(segments[0])
    const isProfileLocation = segments[0].startsWith('@') || segments[0] === 'profile'
    const username = get(user, 'data.user.username')
    const isMyProfile = profileUsername === username || location.pathname === `/@${username}`
    const isMobile = window.innerWidth <= mobileBreakpoint
    const selectedMenuOptions =
      isScrollingMode &&
      (isFeedLocation
        ? getCustomMenuOptions({ feeds: feeds.filter(i => i.get('home')) })
        : isProfileLocation
        ? getProfileMenuOptions({ isInEditPinsMode, profileFeeds, segments, isMyProfile })
        : null)

    let selectedMenuOption =
      selectedMenuOptions && selectedMenuOptions.find(o => o.to === pathname || o.to.pathname === pathname)
    if (!selectedMenuOption && selectedMenuOptions && selectedMenuOptions.size) {
      selectedMenuOption = {
        text: 'Home',
        to: '/'
      }
    }

    const isSearching = window.location && window.location.pathname.includes('search')
    const isCards = window.location && window.location.pathname.includes('cards')
    const isCollections = window.location && window.location.pathname.includes('collections')
    if (isCards) {
      selectedMenuOption = {
        text: 'Cards',
        to: '/cards'
      }
    }
    if (isCollections) {
      selectedMenuOption = {
        text: 'Collections',
        to: '/collections'
      }
    }
    if (isSearching) {
      const { pathname, search: locationSearch } = window.location
      selectedMenuOption = {
        description: 'Search',
        query: {},
        text: 'Search',
        to: `${pathname}${locationSearch}`,
        itemClassName: 'feeds-filter-item--active'
      }
    }

    const headerClasses = cn(headerBaseClass, {
      [headerScrollingClass]: isScrollingMode
    })
    const navBarClasses = cn('header__nav-bar', { 'header__nav-bar--scroll': isScrollingMode })
    const logoTextClasses = cn(logoTextBaseClass, { [logoTextScrollingClass]: isScrollingMode })

    const isInProfile = location.pathname.includes('@')
    let sections = allSections
      .filter(i => (isInProfile ? (feedSections || []).includes(i.get('id')) && !i.get('home') : i.get('home')))
      .toList()
    let defaultSection = { ...defaultFeed }
    let savedSection = { ...savedFeed }
    if (isInProfile) {
      defaultSection.feeds = defaultSection.feeds.map(i => ({ ...i, to: '/@' + profileUser.get('username') + i.to }))
      sections = sections.unshift(fromJS(defaultSection))
      if (showDefaultSavedFeed) {
        savedSection.feeds = savedSection.feeds.map(i => ({ ...i, to: '/@' + profileUser.get('username') + i.to }))
        sections = sections.push(fromJS(savedSection))
      }
    }
    return (
      <header className={headerClasses} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
        <div className={navBarClasses}>
          <div className="header__block header__block--left">
            <NavLink to="/" className="header__brand" activeClassName="header__brand">
              <img
                className={`header__brand-image-symbol ${isScrollingMode ? logoScrollingClass : ''}`}
                alt="Guide Human"
                src={LogoSymbol}
              />
              <img className={logoTextClasses} alt="Guide Human" src={LogoText} />
            </NavLink>
          </div>
          <div
            className={`header__block header__block--right ${isScrollingMode ? 'header__block--right--scroll' : ''}`}
          >
            <MainMenu />
          </div>
        </div>
        <Fade mounted={(selectedMenuOptions && isMouseEntered) || (isMobile && isScrollingMode)} time={150}>
          <div
            className={cn(['header__menu-panel', 'header__menu-panel--expanded'], {
              'header__menu-panel--is-scrolling': isScrollingMode
            })}
          >
            <div className="header__menu-container">
              <Sections
                mods={'in-header' + (isMobile && isScrollingMode) ? 'header-scrolling' : ''}
                options={sections}
                ui={ui}
                setKnobsPanelTopMargin={setKnobsPanelTopMargin}
                isMouseEntered={isMouseEntered}
                isInProfile={isInProfile}
                isScrollingMode={isScrollingMode}
              />
            </div>
          </div>
        </Fade>
      </header>
    )
  }
}

Header.propTypes = {
  location: pt.shape({ pathname: pt.string }),
  mods: pt.shape({}),
  profileUser: pt.shape({}),
  myContent: pt.shape({
    isInEditPinsMode: pt.string
  }),
  feeds: pt.object,
  feedSections: pt.object,
  ui: pt.shape({}),
  setKnobsPanelTopMargin: pt.func,
  user: pt.shape({})
}

const makeMapStateToProps = () => {
  const getProfileUserByUsername = makeGetProfileUserByUsername()
  return (state, props) => {
    const segments = state.location.pathname.substr(1).split('/')
    const username = segments[0].startsWith('@') ? segments[0].substr(1) : null
    return {
      profileUser: getProfileUserByUsername(state, username),
      mods: state.mods,
      myContent: state.myContent,
      location: state.location,
      feeds: state.entities.getIn(['feeds', 'entities']),
      feedSections: state.entities.getIn(['feedSections', 'entities']),
      ui: state.ui,
      user: state.user
    }
  }
}

export default connect(
  makeMapStateToProps,
  { setKnobsPanelTopMargin }
)(Header)
